import { render, staticRenderFns } from "./PhyscSnctnRcrd.vue?vue&type=template&id=3831668f&"
import script from "./PhyscSnctnRcrd.vue?vue&type=script&lang=js&"
export * from "./PhyscSnctnRcrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports